import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import classes from './ProjectOpen.module.scss'
import MonitoringSidebar from './ProjectOpenContent/MonitoringSidebar/MonitoringSidebar'
import ProjectOpenContent from './ProjectOpenContent/ProjectOpenContent'
import { RootState } from '../../../store/store'

const ProjectOpen = () => {
    const { projectUuid } = useParams<{ projectUuid: string }>()
    
    // Получаем состояние левого сайдбара из Redux
    // const isSidebarCollapsed = useSelector((state: RootState) => state.sidebar?.isCollapsed)
    
    // Проверяем, находимся ли мы на странице мониторинга
    const isMonitoringPage = window.location.pathname.includes('/monitoring')
    
    // Определяем класс в зависимости от наличия MonitoringSidebar
    const contentClass = isMonitoringPage 
        ? `${classes.content} ${classes.withSidebar}`
        : classes.content

    return (
        <div className={classes.projectOpenContainer}>
            <div className={contentClass}>
                <div className={classes.mainContent}>
                    <ProjectOpenContent projectUuid={projectUuid} />
                </div>
                {isMonitoringPage && (
                    <div className={classes.monitoringSidebar}>
                        <div className={classes.monitoringSidebarContent}>
                            <MonitoringSidebar/>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ProjectOpen